var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteractiveDashboards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9166 0H3.41656C1.80828 0 0.5 1.30828 0.5 2.91656V10.4166C0.5 12.0252 1.80828 13.3334 3.41656 13.3334H15.9166C17.5252 13.3334 18.8334 12.0252 18.8334 10.4166V2.91656C18.8334 1.30828 17.5252 0 15.9166 0ZM15.9166 16.6666H3.41656C1.80828 16.6666 0.5 17.9748 0.5 19.5834V37.0834C0.5 38.6917 1.80828 40 3.41656 40H15.9166C17.5252 40 18.8334 38.6917 18.8334 37.0834V19.5834C18.8334 17.9748 17.5252 16.6666 15.9166 16.6666ZM37.5834 26.6666H25.0834C23.4748 26.6666 22.1666 27.9748 22.1666 29.5834V37.0834C22.1666 38.6917 23.4748 40 25.0834 40H37.5834C39.1917 40 40.5 38.6917 40.5 37.0834V29.5834C40.5 27.9748 39.1917 26.6666 37.5834 26.6666ZM37.5834 0H25.0834C23.4748 0 22.1666 1.30828 22.1666 2.91656V20.4166C22.1666 22.0252 23.4748 23.3334 25.0834 23.3334H37.5834C39.1917 23.3334 40.5 22.0252 40.5 20.4166V2.91656C40.5 1.30828 39.1917 0 37.5834 0Z",
    fill: "url(#paint0_linear_11686_1872)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11686_1872",
    x1: 5.52533,
    y1: 0.784169,
    x2: 42.2124,
    y2: 29.3865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveDashboards);
export default __webpack_public_path__ + "static/media/interactive-dashboards.879baeb7f85fe0e2459b9c8273e3847c.svg";
export { ForwardRef as ReactComponent };